import React, { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { patchMyCompany } from "@/lib/companyApi";
import { Loader2, CheckCircle2 } from "lucide-react";

export default function CompanySettings() {
  const { company, setCompany } = useOutletContext() || {};
  const [form, setForm] = useState({
    name: company?.name || "",
    website: company?.website || "",
    about: company?.about || "",
    logo: company?.logo || "",
    gstin: company?.gstin || "",
    cin: company?.cin || "",
    domain: company?.domain || "",
  });
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  const ch = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setSaved(false);
    try {
      const { data } = await patchMyCompany(form);
      setCompany(data);
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="container-x py-10 md:py-14 max-w-3xl">
      <span className="overline">Settings</span>
      <h1 className="font-display text-4xl md:text-5xl mt-3 mb-8 leading-tight">
        Company profile
      </h1>

      <form onSubmit={submit} className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <F label="Name" testId="set-name" value={form.name} onChange={ch("name")} full />
        <F label="Logo URL" testId="set-logo" value={form.logo} onChange={ch("logo")} placeholder="https://…" full />
        <F label="Website" testId="set-website" value={form.website} onChange={ch("website")} />
        <F label="Work-email domain" testId="set-domain" value={form.domain} onChange={ch("domain")} />
        <F label="GSTIN" testId="set-gstin" value={form.gstin} onChange={ch("gstin")} />
        <F label="CIN" testId="set-cin" value={form.cin} onChange={ch("cin")} />
        <div className="md:col-span-2">
          <label className="overline">About</label>
          <textarea
            data-testid="set-about"
            value={form.about}
            onChange={ch("about")}
            rows={4}
            className="mt-2 w-full px-4 py-3 rounded-2xl bg-white border border-stone-300 placeholder:text-stone-400 focus:outline-none focus:border-stone-900 text-sm"
          />
        </div>
      </form>

      <div className="mt-8 flex items-center gap-3">
        <button onClick={submit} disabled={saving} data-testid="set-submit" className="btn-primary disabled:opacity-60">
          {saving ? <><Loader2 size={16} className="animate-spin" /> Saving</> : "Save changes"}
        </button>
        {saved && (
          <span className="inline-flex items-center gap-2 text-emerald-700 text-sm" data-testid="set-saved">
            <CheckCircle2 size={14} /> Saved
          </span>
        )}
      </div>
    </div>
  );
}

function F({ label, testId, value, onChange, placeholder, full }) {
  return (
    <div className={full ? "md:col-span-2" : ""}>
      <label className="overline">{label}</label>
      <input
        type="text"
        data-testid={testId}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="mt-2 w-full px-4 py-3 rounded-full bg-white border border-stone-300 placeholder:text-stone-400 focus:outline-none focus:border-stone-900 text-sm"
      />
    </div>
  );
}
